import $ from 'jquery';
import { Form } from '@/components/form/form';
import { destroyAlert, displaySuccess, displayError } from './utils';
export class FormSubscribe {
    constructor() {
        this.selector = '.form-subscribe';
        if ($(this.selector).length === 0)
            return;
        new Form(this.selector, {
            onLoading: () => {
                destroyAlert($(this.selector));
            },
            onSuccess: (data) => {
                displaySuccess($(this.selector), $(this.selector).find('.form-group:last'), data.message);
            },
            onError: (error) => {
                displayError($(this.selector), $(this.selector).find('.form-group:last'), error);
            },
        });
    }
}
